import React from 'react';
import './permutations-and-combinations.css';
import Heading from '../../../../Miscs/Heading/Heading';

const PermutationsAndCombinations = () => {
	return (
		<>
			<div className="permutations-and-combinations">
				<Heading>Permutations And Combinations</Heading>
			</div>
		</>
	);
};

export default PermutationsAndCombinations;
